module.exports = __webpack_public_path__ + "static/media/arrow-right.d9978e57.svg";